import React, { useEffect, Fragment, useState } from "react";
import { Button, Container, Row, Col, Input, Label, FormGroup } from "reactstrap";
import { GetCookieToken } from "../Cookie/GetCookie";
import Select from 'react-select';
import { FetchAxiosGet, FetchAxiosPost } from "../../api/axios"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";
import UserSelector from "../../components/users/UsersSelector";

function LeaveConfig(props) {
    const userToken = GetCookieToken("userToken");
    const API_URL = process.env.REACT_APP_API_CORS;
    const { userInfo } = props
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(true);
    const [leaveType, setLeaveType] = useState([]);
    const [orgOptions, setOrgOptions] = useState([]);
    const [checkbox, setCheckbox] = useState({});
    const [checkboxForLeader, setCheckboxForLeader] = useState({});
    const [checkboxDisabled, setSheckboxDisabled] = useState(true);
    const [org, setOrg] = useState(null);
    const [orgLeader, setOrgLeader] = useState([]);
    const [leaveTypeData, setLeaveTypeData] = useState(null);
    const [responseData, setResponseData] = useState([]);
    const [psacApproveUser, setPsacApproveUser] = useState(null);

    const updateData = async (users_position_id = null, e = null, for_leader = null) => {
        if (users_position_id && e) {
            let data = {
                users_position_id: users_position_id,
                org_id: org,
                leave_type_id: leaveTypeData,
                status: e?.target?.checked ? 1 : 0,
                for_leader: for_leader
            }

            let response = await FetchAxiosPost('/api/leave/config/flow/editByData', data, userToken);
        }
    }

    useEffect(() => {
        let thisEffect = async () => {

            const config = await FetchAxiosGet('/api/leave/config/all', userToken);
            const orgInner = await FetchAxiosGet('/api/orgInner/level', userToken);
            setLeaveType(config?.form_leave)

            let options = [{ value: '0', label: 'ทั้งหมด' }];
            await orgInner?.result?.child?.map(async x => {
                if (x?.active === 1) {
                    options.push({ value: x?.org_id, label: x?.org_name })
                }
                // x.child && x.child.map(y => {
                //     options.push({ value: y.org_id, label: y.org_name })
                //     y.child && x.child.map(z => {
                //         options.push({ value: z.org_id, label: z.org_name })
                //     })
                // })
            })
            options = options?.filter((obj, index, self) => {
                return index === self?.findIndex((t) => (
                    t?.value === obj?.value
                ));
            });
            setOrgOptions(options)

        }
        thisEffect()
        getPsacDataTable()
    }, [])

    useEffect(() => {
        setSheckboxDisabled(true)
        let thisEffect = async () => {

            setLoading(true)
            setCheckbox({})
            setResponseData([])
            const url = `${API_URL}/api/leave/config/flow/datatable`;
            const params = new URLSearchParams({
                page: 1,
                size: 20,
                "order[0]": "users_position_id",
                "order[1]": "DESC",
                "filter[org_id][0]": org,
                "filter[leave_type_id][0]": leaveTypeData,
                "filter[for_leader][0]": 0,
                "filter[for_leader][1]": 1,
                "filter[status][0]": 1
            });
            const config = {
                headers: { Authorization: `Bearer ${userToken}` }, params
            };

            await axios.get(url, config).then(async response => {
                setResponseData(response?.data?.result)
            }).catch(error => console.error("Error:", error))

        }
        if (org && leaveTypeData) { thisEffect(); setSheckboxDisabled(false); }
    }, [org, leaveTypeData])

    useEffect(() => {
        setLoading(true)
        let thisEffect = async () => {
            let thisCheckbox = {};
            let thisCheckboxForLeader = {};

            for await (const [k, v] of Object.entries(responseData)) {
                const posId = `${v?.users_position_id}`;

                thisCheckbox[posId] = thisCheckbox[posId] || v?.for_leader === 0;
                thisCheckboxForLeader[posId] = thisCheckboxForLeader[posId] || v?.for_leader === 1;
            }
        
            setCheckbox(thisCheckbox);
            setCheckboxForLeader(thisCheckboxForLeader);
            setTimeout(() => {
                setLoading(false);
            }, 300);
        };
        (responseData) ? thisEffect() : setLoading(false)
    }, [responseData])

    useEffect(() => {
        if (userInfo) {
            if (
                !CheckPosition(userInfo?.position) &&
                !CheckSubAdmin(userInfo?.positionSubAdmin)
            ) {
                navigate("/setdata");
            }
        }
    }, [userInfo]);

    useEffect(() => {
        let thisEffect = async () => {
            if (org) {
                const orgApprovalSequence = (await FetchAxiosGet(`/api/approvalSequence/org/${org}`, userToken))?.result;
                // orgApprovalSequence.map(x => {
                //     let t = [];
                //     t[x.position_id] = x.user_name
                //     setOrgLeader([...orgLeader, ...t])
                // })
                setOrgLeader(orgApprovalSequence);
            }
        }
        thisEffect();
    }, [org])

    // console.log(ch);

    const [psacApproveUserData, setPsacApproveUserData] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null);
    const getPsacDataTable = async () => {
        setLoading(true)
        setPsacApproveUserData([])
        const url = `${API_URL}/api/psacApproveUser/datatable`;
        const params = new URLSearchParams({
            page: 1,
            size: 20,
            "order[0]": "id",
            "order[1]": "DESC",
            "filter[status][0]": 1
        });
        const config = {
            headers: { Authorization: `Bearer ${userToken}` }, params
        };

        await axios.get(url, config).then(async response => {
            const data = response?.data?.result
            if (data && data?.lenght !== 0) {
                setPsacApproveUserData(data[0])
            }
        }).catch(error => console.error("Error:", error))
    }

    useEffect(() => {
        if (psacApproveUserData?.approve_user_id && !selectedUser) {
            let value = { user_id: psacApproveUserData?.approve_user_id, user_name: psacApproveUserData?.approve_user_name }
            setSelectedUser(value)
        }
    }, [psacApproveUserData])

    const updatePsacData = async (user_id, user_name) => {
        if (user_id && user_name) {
            let data = {
                approve_user_id: user_id,
                approve_user_name: user_name,
                status: 1
            }

            let response = await FetchAxiosPost('/api/psacApproveUser/editByData', data, userToken);
        }
    }

    return (
        <Fragment>
            <div className="w-100 card p-3 shadow">
                <h4><i className="fa-solid fa-users-gear pe-2 pb-2"></i>ตั้งค่าลำดับอนุมัติการลา</h4>
                <Row>
                    <Col sm={12} lg={6} mb={6}>
                        <FormGroup>
                            <Label for="orgId">
                                สำนัก/กอง
                            </Label>
                            {orgOptions ? <Select
                                className="basic-single"
                                classNamePrefix="สำนัก/กอง"
                                defaultValue='0'
                                isSearchable={true}
                                name="color"
                                placeholder='สำนัก/กอง...'
                                options={orgOptions}
                                onChange={(e) => { setOrg(e?.value) }}
                            /> : <h5><i class="fa-duotone fa-spinner-third fa-spin"></i></h5>}
                        </FormGroup>
                    </Col>
                    <Col sm={12} lg={6} mb={6}></Col>
                    <Col sm={12} lg={6} mb={6}>
                        <FormGroup>
                            <Label for="leaveType">
                                ประเภทการลา
                            </Label> 
                            <Input
                                id="leaveType"
                                name="leaveType"
                                placeholder="ประเภทการลา"
                                type="select"
                                onChange={(e) => { setLeaveTypeData(e.target.value) }}
                            >
                                <option value=''>เลือกประเภทการลา ...</option>
                                {leaveType && leaveType.map(x => {
                                    return x?.leave_type && x?.leave_type.map((y, i) => <option value={y?.leave_type_id}>{y?.leave_name}</option>)
                                })}
                            </Input>
                        </FormGroup>
                    </Col>
                    {/* {console.log(checkbox)} */}
                    <Col sm={12} lg={6} mb={6}></Col>
                    {(!loading && show) ? <Row className="border-top">
                        <Col sm={6} lg={6} mb={6} className="py-3">
                        {leaveTypeData === "5" && <span className="fw-bold fs-6 mb-1">ลำดับปกติ (ตั้งแต่ระดับ ผู้เชี่ยวชาญลงมา)</span>}
                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="7" id="checkbox7" defaultChecked={checkbox?.['7'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '7': !checkbox?.['7'] });
                                    await updateData(7, e, 0)
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox7">
                                ผู้อำนวยการกลุ่ม / ผู้เชี่ยวชาญกลุ่ม {orgLeader?.find(x => x?.position_id === 7) ? `(${orgLeader?.find(x => x?.position_id === 7).user_name})` : ''}
                            </label>
                        </div>

                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="6" id="checkbox6" defaultChecked={checkbox?.['6'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '6': !checkbox?.['6'] });
                                    await updateData(6, e, 0);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox6">
                                ผู้เชี่ยวชาญกอง {orgLeader?.find(x => x?.position_id === 6) ? `(${orgLeader?.find(x => x?.position_id === 6)?.user_name})` : ''}
                            </label>
                        </div>

                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="5" id="checkbox5" defaultChecked={checkbox?.['5'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '5': !checkbox?.['5'] });
                                    await updateData(5, e, 0);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox5">
                                ผู้อำนวยการกอง {orgLeader?.find(x => x?.position_id === 5) ? `(${orgLeader?.find(x => x?.position_id === 5)?.user_name})` : ''}
                            </label>
                        </div>

                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="4" id="checkbox4" defaultChecked={checkbox?.['4'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '4': !checkbox?.['4'] });
                                    await updateData(4, e, 0);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox4">
                                ผู้ช่วยเลขาธิการ ก.พ.ร. {orgLeader?.find(x => x?.position_id === 4) ? `(${orgLeader?.find(x => x?.position_id === 4)?.user_name})` : ''}
                            </label>
                        </div>

                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="3" id="checkbox3" defaultChecked={checkbox?.['3'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '3': !checkbox?.['3'] });
                                    await updateData(3, e, 0);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox3">
                                รองเลขาธิการ ก.พ.ร. / ที่ปรึกษาเลขาธิการ ก.พ.ร. {orgLeader?.find(x => x?.position_id === 3) ? `(${orgLeader?.find(x => x?.position_id === 3)?.user_name})` : ''}
                            </label>
                        </div>
                        {/* <div className="form-check">
                            <Input className="form-check-input" type="checkbox" value="3" id="checkbox3" defaultChecked={checkbox?.['3'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '3': !checkbox?.['3'] });
                                    await updateData(3, e);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox3">
                                ที่ปรึกษาเลขาธิการ ก.พ.ร.
                            </label>
                        </div> */}
                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="2" id="checkbox2" defaultChecked={checkbox?.['2'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '2': !checkbox?.['2'] });
                                    await updateData(2, e, 0);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox2">
                                เลขาธิการ ก.พ.ร. {orgLeader?.find(x => x?.position_id === 2) ? `(${orgLeader?.find(x => x?.position_id === 2)?.user_name})` : ''}
                            </label>
                        </div>
                        </Col>

                        {/* สำหรับ ผอ.กอง */}
                        {leaveTypeData === "5" && <Col sm={6} lg={6} mb={6} className="border-top pt-3">
                        <span className="fw-bold fs-6">สำหรับผู้อำนวยการกอง</span>

                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="4" id="checkbox4" defaultChecked={checkbox?.['4'] || false}
                                onClick={async (e) => {
                                    setCheckbox({ ...checkbox, '4': !checkbox?.['4'] });
                                    await updateData(4, e, 1);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox4">
                                ผู้ช่วยเลขาธิการ ก.พ.ร. {orgLeader?.find(x => x?.position_id === 4) ? `(${orgLeader?.find(x => x?.position_id === 4)?.user_name})` : ''}
                            </label>
                        </div>

                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="3" id="checkboxForLeader3" defaultChecked={checkboxForLeader?.['3'] || false}
                                onClick={async (e) => {
                                    setCheckboxForLeader({ ...checkboxForLeader, '3': !checkboxForLeader?.['3'] });
                                    await updateData(3, e, 1);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkbox3">
                                รองเลขาธิการ ก.พ.ร. / ที่ปรึกษาเลขาธิการ ก.พ.ร. {orgLeader?.find(x => x?.position_id === 3) ? `(${orgLeader?.find(x => x?.position_id === 3)?.user_name})` : ''}
                            </label>
                        </div>
                        <div className="form-check mt-1">
                            <Input className="form-check-input" type="checkbox" value="2" id="checkboxForLeader2" defaultChecked={checkboxForLeader?.['2'] || false}
                                onClick={async (e) => {
                                    setCheckboxForLeader({ ...checkboxForLeader, '2': !checkboxForLeader?.['2'] });
                                    await updateData(2, e, 1);
                                }}
                                disabled={checkboxDisabled}
                            />
                            <label className="form-check-label" for="checkboxForLeader2">
                                เลขาธิการ ก.พ.ร. {orgLeader?.find(x => x?.position_id === 2) ? `(${orgLeader?.find(x => x?.position_id === 2)?.user_name})` : ''}
                            </label>
                        </div>
                        </Col>}
                    </Row> : <Col sm={12} lg={6} mb={6}><h5><i class="fa-duotone fa-spinner-third fa-spin"></i></h5></Col>
                    }

                    <Col sm={12} lg={12} mb={12} className="border-top pt-3">
                        <Col sm={6} lg={6} mb={6}>
                            <Label for="psacApproveUser">
                                หัวหน้าฝ่ายโครงการ นปร.
                            </Label>
                            <UserSelector
                              type="normal"
                              placeholder="เลือกผู้ใช้งาน"
                              value={{value: selectedUser, label: selectedUser?.user_name}}
                              onChange={(v) => {
                                    updatePsacData(v?.user_id, v?.user_name)
                                    setSelectedUser(v)
                                }
                              }
                              disabled={false}
                              className=""
                            />
                        </Col>
                    </Col>
                </Row>
            </div>
        </Fragment >
    );
}

export default LeaveConfig;
